import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DictionarySignalPipe } from 'src/app/dictionary/pipes/dictionary-signal.pipe';
import { ConnectivityService } from './connectivity.service';

// NOTE: Mirrors MobileQueueChipComponent's visual language (fixed pill,
// SlideDown animation, soft shadow). Sits at the top so it doesn't
// collide with the queue chip anchored to the bottom.

@Component({
  selector: 'app-mobile-offline-banner',
  standalone: true,
  imports: [DictionarySignalPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (isOffline()) {
      <div class="offline-chip" role="status" aria-live="polite">
        <span class="offline-chip-text">
          {{
            ('mobileofflinebanner_message' | dictionarySignal)() ||
              'No internet connection'
          }}
        </span>
      </div>
    }
  `,
  styles: [
    `
      :host {
        position: fixed;
        top: calc(env(safe-area-inset-top) + 8px);
        left: 50%;
        transform: translateX(-50%);
        z-index: 1000;
        pointer-events: none;
      }

      .offline-chip {
        pointer-events: auto;
        background: var(--appBackground, #fff);
        border: 1px solid var(--errorBar, #b00020);
        border-radius: 1.5rem;
        padding: 0.4rem 0.9rem;
        max-width: 85vw;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        animation: chipSlideDown 0.3s ease-out;
      }

      .offline-chip-text {
        font-family: var(--main-font-family);
        font-size: 0.8rem;
        font-weight: 500;
        color: var(--secondaryAccentColor, #333);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      @keyframes chipSlideDown {
        from {
          opacity: 0;
          transform: translateY(-1rem);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `,
  ],
})
export class MobileOfflineBannerComponent {
  private readonly connectivity = inject(ConnectivityService);

  protected readonly isOffline = this.connectivity.isOffline;
}
